var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.loading,"variant":"white","opacity":1}},[_c('reviews-grid',{attrs:{"rating":_vm.rating,"average-rating":_vm.averageRating,"max-rating":_vm.MAX_REVIEW_RATING,"reviews":_vm.reviews}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }